define("shared/utils/formatters/th-post-from-dynamo", ["exports", "later/models/th-post"], function (_exports, _thPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/th-post"eaimeta@70e063a35619d71f
  /**
   * Converts a raw threads dynamo post into a DynamoThreadsPost
   *
   */
  function createThreadsPostFromDynamo(obj, socialProfile) {
    const engagement = convertToNumberOrUndefined(obj.views) ? (calculateEngagements(obj) ?? 0) / obj.views : 0;
    return new _thPost.default({
      socialProfile,
      id: obj.id,
      createdAtUnix: obj.created_time,
      createdTime: obj.created_time,
      url: obj.url,
      imageUrl: obj.thumbnail_url ?? obj.media_url,
      views: convertToNumberOrUndefined(obj.views),
      reposts: convertToNumberOrUndefined(obj.reposts),
      likes: convertToNumberOrUndefined(obj.likes),
      replies: convertToNumberOrUndefined(obj.replies),
      quotes: convertToNumberOrUndefined(obj.quotes),
      laterPostId: obj.later_post_id,
      mediaId: obj.media_id,
      mediaType: obj.media_type,
      permalink: obj.permalink,
      shares: obj.shares,
      shortcode: obj.shortcode,
      text: obj.text,
      engagements: convertToNumberOrUndefined(calculateEngagements(obj)),
      engagement: convertToNumberOrUndefined(engagement)
    });
  }
  function calculateEngagements(obj) {
    const {
      quotes,
      replies,
      likes
    } = obj;
    if (likes === undefined && replies === undefined && quotes === undefined) {
      return undefined;
    }
    return (likes ?? 0) + (replies ?? 0) + (quotes ?? 0);
  }
  function convertToNumberOrUndefined(input) {
    return input ? Number(input) : undefined;
  }
  var _default = _exports.default = createThreadsPostFromDynamo;
});